var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.48364C1 4.95321 1.21071 4.4445 1.58579 4.06943C1.96086 3.69436 2.46957 3.48364 3 3.48364H6.28C6.48979 3.4838 6.69422 3.54994 6.86436 3.67269C7.03449 3.79545 7.1617 3.9686 7.228 4.16764L8.726 8.66064C8.8019 8.88898 8.79293 9.13703 8.70072 9.35929C8.60851 9.58154 8.43925 9.7631 8.224 9.87064L5.967 11.0006C7.07332 13.4492 9.03446 15.4103 11.483 16.5166L12.613 14.2596C12.7205 14.0444 12.9021 13.8751 13.1244 13.7829C13.3466 13.6907 13.5947 13.6817 13.823 13.7576L18.316 15.2556C18.5152 15.322 18.6885 15.4494 18.8112 15.6197C18.934 15.79 19.0001 15.9947 19 16.2046V19.4836C19 20.0141 18.7893 20.5228 18.4142 20.8979C18.0391 21.2729 17.5304 21.4836 17 21.4836H16C7.716 21.4836 1 14.7676 1 6.48364V5.48364Z",
    stroke: "#0B4725",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/PhoneOutline.e21d15a80c274ff759859d3cf8862003.svg";
export { ForwardRef as ReactComponent };